import { render } from "./KidsView.vue?vue&type=template&id=50bfebc6&scoped=true"
import script from "./KidsView.vue?vue&type=script&lang=js"
export * from "./KidsView.vue?vue&type=script&lang=js"

import "./KidsView.vue?vue&type=style&index=0&id=50bfebc6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bfebc6"]])

export default __exports__